import React from 'react'
import {
  FloatingInspectorButton,
  FloatingInspectorButtonProps,
  MainText,
  SecondText,
} from '../FloatingInspectorButton'
import { useTranslation } from 'react-i18next'

export interface TextTwoSectionsProps
  extends Pick<
    FloatingInspectorButtonProps,
    'onClick' | 'selected' | 'disabled' | 'showBorder' | 'tooltipText' | 'placementTooltip' | 'marginTooltip'
  > {
    text: string
    secondText: string
  }

const TextTwoSections: React.FC<TextTwoSectionsProps> = ({
  text,
  secondText,
  onClick,
  selected,
  disabled,
  tooltipText,
  placementTooltip,
  marginTooltip,
}) => {
  const [t] = useTranslation()
  return (
  <FloatingInspectorButton
    onClick={onClick}
    selected={selected}
    disabled={disabled}
    widthType={'FixedTextTwoSections'}
    showBorder={true}
    tooltipText={tooltipText}
    placementTooltip={placementTooltip}
    marginTooltip={marginTooltip}
  >
    <MainText>{t(text)}</MainText>
    <SecondText>{secondText}</SecondText>
  </FloatingInspectorButton>
)
}

export default TextTwoSections